/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Observable } from 'rxjs';

export interface IButtonResult {
  title?: string;
}

export type ButtonResult = IButtonResult | void;

export type ClickResult<T> = Observable<T> | T;

export interface IClickable<T> {
  click: () => ClickResult<T>;
}

export interface ITextButton<T extends IButtonResult | void> extends IButtonResult, IClickable<T> {
  name: string;
  width?: string;
  isPrimary?: boolean;
  isDisabled?: () => boolean;
  isBordered?: boolean;
  imageSrc?: string;
}

export interface IDynamicState {
  isDisabled?: () => boolean;
}

export function isDisabled(item: IDynamicState): boolean {
  return item.isDisabled !== undefined && item.isDisabled();
}
